import { cn } from "@/utils/cn";
import { PHONE_MASK, formatPhoneDisplay } from "@/hooks/useDemographicsForm";

/** Shared bits for the insurance capture forms (Auto / Workers' Comp / Health). */

export const ERROR_INPUT_CLASS = "border-red-500 focus:ring-red-500";

export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="mt-1 text-xs font-semibold text-red-600">{message}</p>;
}

/** A US phone is complete at 10 digits. */
export const isValidPhone = (v: string) => v.replace(/\D/g, "").length === 10;

/** Digits only (max 10) — what we persist. */
export const phoneDigits = (v: string) => PHONE_MASK(v);

export { formatPhoneDisplay, cn };
